import createTerrainWorker from "./createTerrainWorker.js";

export default class WorkerPool {
    constructor() {
        const count = Math.max(1, (navigator.hardwareConcurrency || 4) - 1);
        this.workers = [];
        this.queue = [];
        this.waiters = new Map();
        this.nextId = 1;

        for (let i = 0; i < count; i++) {
            const worker = createTerrainWorker();
            const entry = { worker, busy: false };
            worker.onmessage = (event) => {
                const data = event.data;
                const resolve = this.waiters.get(data.id);
                if (resolve) {
                    this.waiters.delete(data.id);
                    resolve(data);
                }
                entry.busy = false;
                this._pump();
            };
            worker.onerror = (error) => {
                console.error(error);
                entry.busy = false;
                this._pump();
            };
            this.workers.push(entry);
        }
    }

    generate(layout, resolution) {
        return this._job({ type: "generate", layout, resolution });
    }

    mesh(spec) {
        return this._job({ type: "mesh", spec });
    }

    broadcastHeights(heights, worldSize) {
        for (let i = 0; i < this.workers.length; i++) {
            const copy = new Int16Array(heights);
            this.workers[i].worker.postMessage(
                { type: "heights", heights: copy, worldSize },
                [copy.buffer],
            );
        }
    }

    patch(index, height, i, j) {
        for (let n = 0; n < this.workers.length; n++) {
            this.workers[n].worker.postMessage({ type: "patch", index, height, i, j });
        }
    }

    _job(message) {
        return new Promise((resolve) => {
            const id = this.nextId++;
            this.waiters.set(id, resolve);
            this.queue.push({ id, message });
            this._pump();
        });
    }

    _pump() {
        if (this.queue.length > 1) {
            this.queue.sort(
                (a, b) => (a.message.spec?.dist ?? 0) - (b.message.spec?.dist ?? 0),
            );
        }
        for (let i = 0; i < this.workers.length; i++) {
            const entry = this.workers[i];
            if (entry.busy) continue;
            const job = this.queue.shift();
            if (!job) return;
            entry.busy = true;
            entry.worker.postMessage({ ...job.message, id: job.id });
        }
    }
}
